import { render, staticRenderFns } from "./DefaultReports.vue?vue&type=template&id=6fbe1e2e"
import script from "./DefaultReports.vue?vue&type=script&lang=ts"
export * from "./DefaultReports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fbe1e2e')) {
      api.createRecord('6fbe1e2e', component.options)
    } else {
      api.reload('6fbe1e2e', component.options)
    }
    module.hot.accept("./DefaultReports.vue?vue&type=template&id=6fbe1e2e", function () {
      api.rerender('6fbe1e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/DefaultReports.vue"
export default component.exports